import { render } from "./PeoplePratt.vue?vue&type=template&id=56fa23e0"
import script from "./PeoplePratt.vue?vue&type=script&lang=js"
export * from "./PeoplePratt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__